module.exports = __webpack_public_path__ + "img/back05_sp.3e7aede2.jpg";